import { h, Component } from 'preact';
import JsBarcode from 'jsbarcode';

class Barcode extends Component {
    setRef = el => { this.el = el; };

    componentDidMount() { this.renderBarcode(); }
    componentDidUpdate() { this.renderBarcode(); }

    renderBarcode() {
        const {
            value,
            barWidth = 3,           // Increased for better scanning
            barHeight = 80,         // Increased height for better scanning
            showText = false,
            format = 'CODE128',     // Allow format override
            margin = 10,            // Default margin
            marginTop,
            marginRight,
            marginBottom,
            marginLeft,
            textMargin,
            fontSize = 14,          // Default font size for barcode text
            style = '',
            preserveAspectRatio,
        } = this.props;

        if (!this.el || !value) return;

        JsBarcode(this.el, value, {
            format: format,
            width: barWidth,
            height: barHeight,
            displayValue: showText,
            fontSize: fontSize,
            textMargin: textMargin !== undefined ? textMargin : (showText ? 2 : 0),
            margin: margin,
            marginTop: marginTop !== undefined ? marginTop : margin,
            marginRight: marginRight !== undefined ? marginRight : margin,
            marginBottom: marginBottom !== undefined ? marginBottom : margin,
            marginLeft: marginLeft !== undefined ? marginLeft : margin,
            background: '#ffffff',   // ✅ White background for contrast
            lineColor: '#000000'     // ✅ Black bars for contrast
        });

        // JsBarcode overwrites the svg's style attribute (setSvgAttributes does
        // svg.setAttribute('style', 'transform: translate(0,0)')) together with
        // fixed width/height attributes. Anything passed via the style prop is
        // therefore wiped by the time the barcode is drawn — re-apply it here or
        // e.g. `width: 100%` silently has no effect. Only touched when a style is
        // actually passed, so barcodes without one keep JsBarcode's own styling.
        if (style) {
            this.el.setAttribute('style', `display:block; vertical-align:top; transform: translate(0,0); ${style}`);
        }
        if (preserveAspectRatio) {
            this.el.setAttribute('preserveAspectRatio', preserveAspectRatio);
        }
    }

    render() {
        const { value, style = '', className = '' } = this.props;
        if (!value) return null;
        return (
            <svg
                class={className}
                ref={this.setRef}
                style={`display:block; vertical-align:top; ${style}`}  /* removes inline baseline gap */
            />
        );
    }
}

export default Barcode;
